module.exports = "mat-sidenav {\n  width: 50%; }\n\n.laterondertekenen {\n  width: 100%;\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main